import { useFeatureFlag } from '@fs/zion-flags'
import {
  JUNE_2026_COLLECTION_IDS,
  MAY_2026_COLLECTION_IDS,
  US_CENSUS_CMS_COLLECTION_FLAG_IDS,
  WIKI_COLLECTION_IDS,
} from './collectionConstants'

export default function useCmsCollectionGating() {
  const cmsCollectionsFlag = useFeatureFlag('search_cmsCollections')
  const cmsHrFlag = useFeatureFlag('search_cmsCollectionsHr')
  const usCensusFlag = useFeatureFlag('search_cmsCollectionsUSCensus')
  const cmsMay2026Flag = useFeatureFlag('search_cmsCollectionsMay2026')
  const cmsJune2026Flag = useFeatureFlag('search_cmsCollectionsJune2026')

  // Whether to render the CMS route for a given collection (used for routing in App.js)
  const isCmsEnabledForId = (id) =>
    cmsCollectionsFlag?.isOn ||
    cmsHrFlag?.isOn ||
    (usCensusFlag?.isOn && US_CENSUS_CMS_COLLECTION_FLAG_IDS.has(id)) ||
    WIKI_COLLECTION_IDS.has(id) ||
    (cmsMay2026Flag?.isOn && MAY_2026_COLLECTION_IDS.has(id)) ||
    (cmsJune2026Flag?.isOn && JUNE_2026_COLLECTION_IDS.has(id))

  // Whether to embed the wiki about section (English-only for wiki collections; census always excluded)
  const shouldEmbedWikiAbout = (id, isEnglish) =>
    (cmsCollectionsFlag?.isOn ||
      cmsHrFlag?.isOn ||
      (isEnglish && WIKI_COLLECTION_IDS.has(id)) ||
      (cmsMay2026Flag?.isOn && MAY_2026_COLLECTION_IDS.has(id)) ||
      (cmsJune2026Flag?.isOn && JUNE_2026_COLLECTION_IDS.has(id))) &&
    !US_CENSUS_CMS_COLLECTION_FLAG_IDS.has(id)

  return { cmsCollectionsFlag, isCmsEnabledForId, shouldEmbedWikiAbout }
}
